import React from "react"
import * as styles from "./JobsSearch.module.scss"

const JobsSearch = ({ valueChanged }) => {
  return (
    <div className={styles.inputHolder}>
      <input
        type="text"
        onKeyUp={e => valueChanged(e.target.value)}
        className={styles.inputSearch}
        placeholder="Type to search..."
      />
    </div>
  )
}

export default JobsSearch
